import type { AnimationEvent } from '@angular/animations';
import { CdkDialogContainer, DialogModule } from '@angular/cdk/dialog';
import { PortalModule } from '@angular/cdk/portal';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
} from '@angular/core';
import { modalOpenAndLeave } from './modal-animated-container.animation';

@Component({
  selector: 'palantir-modal-animated-container',
  templateUrl: './modal-animated-container.component.html',
  styleUrls: ['./modal-animated-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [DialogModule, PortalModule],
  animations: [modalOpenAndLeave],
})
/**
 * Animated container for Palantir modals.
 * Extends Angular CDK dialog container to add custom animation handling.
 * Emits animation events and controls exit animation state.
 */
export class PalantirModalAnimatedContainerComponent extends CdkDialogContainer {
  @HostBinding('@slideInOut') public animationState: 'closed' | 'open' | 'void' = 'open';

  public animationStateChanged = new EventEmitter<AnimationEvent>();

  @HostListener('@slideInOut.start', ['$event'])
  public onAnimationStart($event: AnimationEvent) {
    this.animationStateChanged.emit($event);
  }

  @HostListener('@slideInOut.done', ['$event'])
  public onAnimationDone($event: AnimationEvent) {
    this.animationStateChanged.emit($event);
  }

  public startExitAnimation() {
    this.animationState = 'closed';
  }
}
